'use client';
import { Box, Container, Flex, Text, VStack } from '@chakra-ui/react';
import Link from 'next/link';
import { Logo } from '../ui/svgs/logo';
import { useParams, usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import nProgress from 'nprogress';
import { useState, useEffect } from 'react';
import { HeaderMenuCloseIcon, HeaderMenuIcon } from '../ui/svgs/headerMenuIcon';
import TouchableOpacity from '../ui/TouchableOpacity';

export function NavMobile() {
  const params = useParams();
  const locale = (params?.locale as string) || 'zh-CN';

  const [menuOpened, setMenuOpened] = useState(false);

  const pathname = usePathname();
  const searchParams = useSearchParams();

  const isTraderPage = pathname.split('/').includes('trader')

  useEffect(() => {
    setMenuOpened(false);
  }, [pathname, searchParams]);

  // 阻止背景滚动穿透
  useEffect(() => {
    if (menuOpened) {
      // 保存当前滚动位置
      const scrollY = window.scrollY;

      // 锁定 body 滚动
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';

      return () => {
        // 恢复滚动
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';

        // 恢复滚动位置
        window.scrollTo(0, scrollY);
      };
    }
  }, [menuOpened]);

  if (isTraderPage) {
    return null;
  }

  return (
    <Box py={2.5} px={4} h="3.75rem">
      <Flex align="center" justify="space-between">
        <Logo logoJumpUrl='/home' />

        <TouchableOpacity onClick={() => setMenuOpened(!menuOpened)} >
          {menuOpened ? (
            <HeaderMenuCloseIcon />
          ) : (
            <HeaderMenuIcon />
          )}
        </TouchableOpacity>

        {menuOpened && (
          <Box
            position="fixed"
            top={`3.75rem`}
            bottom={0}
            left={0}
            right={0}
            bg="bg.t0"
            zIndex={1000}
            overflowY="auto"
            css={{
              // iOS 滚动优化
              WebkitOverflowScrolling: 'touch',
              // 阻止触摸事件冒泡到底层
              touchAction: 'pan-y',
            }}
          >
            <Box p={4}>
              <Link
                href={`/${locale}/app`}
                onClick={() => {
                  setMenuOpened(false);
                }}
              >
                <Box py={4} px={2}>
                  <Text fontSize="md">
                    App
                  </Text>
                </Box>
              </Link>

              <Link
                href={`/${locale}/marketplace`}
                onClick={() => {
                  setMenuOpened(false);
                }}
              >
                <Box py={4} px={2}>
                  <Text fontSize="md">
                    X402 Market Place
                  </Text>
                </Box>
              </Link>
              
              <Link
                href={`/${locale}/document`}
                onClick={() => {
                  setMenuOpened(false);
                }}
              >
                <Box py={4} px={2}>
                  <Text fontSize="md">
                    Documentation
                  </Text>
                </Box>
              </Link>
            </Box>
          </Box>
        )}
      </Flex>
    </Box>
  );
}
